<template>
    <div >


<Transition name="rightOpen">
    <div v-if="showNotis" class="openProductModal pc-right_modal">
        <div v-if="isMobile" class="button_go_back" @click="openNoti();">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><polyline points="15 18 9 12 15 6"></polyline></svg> 
          <span>Назад</span>
          <span class="button_go_back_title">Уведомления</span>
        </div>
        <div v-else class="modal-close-pc"><span class="modal-close-pc-title">Уведомления</span> <svg @click="openNoti();" viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg></div>
        <Noti :isMobile="isMobile"/>
    </div>
</Transition>

      <Transition name="rightOpen">
    <div v-if="showCart" class="openProductModal pc-right_modal">
        <div v-if="isMobile" class="button_go_back" @click="openCart();">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><polyline points="15 18 9 12 15 6"></polyline></svg> 
          <span>Назад</span>
          <span class="button_go_back_title">Корзина</span>
        </div>
        <div v-else class="modal-close-pc"><span class="modal-close-pc-title">Корзина</span> <svg @click="openCart();" viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg></div>
        <Cart :cart="cart" :order="order" :isMobile="isMobile" :cartMarkets="cartMarkets" :hasShop="hasShop" @closeCart="openCart"/>
    </div>
</Transition>

<Transition name="rightOpen">
    <div v-if="showOrders" class="openProductModal pc-right_modal">
        <div v-if="isMobile" class="button_go_back" @click="openOrders();">
          <svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><polyline points="15 18 9 12 15 6"></polyline></svg> 
          <span>Назад</span>
          <span class="button_go_back_title">Мои заказы</span>
        </div>
        <div v-else class="modal-close-pc"><span class="modal-close-pc-title">Мои заказы</span> <svg @click="openOrders();" viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round" stroke-linejoin="round" class="css-i6dzq1"><circle cx="12" cy="12" r="10"></circle><line x1="15" y1="9" x2="9" y2="15"></line><line x1="9" y1="9" x2="15" y2="15"></line></svg></div>
        <Orders :isMobile="isMobile" @openOrders="openOrders"/>
    </div>
</Transition>

<header class="p-3 mb-3 header-navbar">
    <div class="container">
      <div class="d-flex flex-wrap align-items-center justify-content-center justify-content-start">
        
        <a v-if="platform?.domen == 'wed-oplata.lenteres.ru'"  href="https://wedding.lenteres.ru/" class="d-flex align-items-center mb-lg-0 text-dark text-decoration-none me-auto router-link-active">
            <div class="row">
              
              <div v-if="platform.logo != null" class="headerlogo_photo">
                <img :src="platform.logo" alt="logo">
              </div>
                 <div v-else class="logo_svg">
                  <svg  xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-layers"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>
                </div>
                 <div class="logo_name" :class="[platform?.type == 'trc' || platform?.type == 'photo' || platform?.type != null  ? 'auto-width' : '']">{{ platform.name }}</div>
                </div>
          </a>
        <router-link v-else to="/" class="d-flex align-items-center mb-lg-0 text-dark text-decoration-none me-auto router-link-active">
            <div class="row">
              
              <div v-if="platform.logo != null" class="headerlogo_photo">
                <img :src="platform.logo" alt="logo">
              </div>
                 <div v-else class="logo_svg">
                  <svg  xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-layers"><polygon points="12 2 2 7 12 12 22 7 12 2"></polygon><polyline points="2 17 12 22 22 17"></polyline><polyline points="2 12 12 17 22 12"></polyline></svg>
                </div>
                 <div class="logo_name" :class="[platform?.type == 'trc' || platform?.type == 'photo' || platform?.type != null  ? 'auto-width' : '']">{{ platform.name }}</div>
                </div>
        </router-link>

        <!-- <form class="col-auto mb-0 me-lg-3 header_serach">
            <span class="h-search_icon">
                 <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-search"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
             </span>
            <input type="search" class="form-control" placeholder="Поиск..." aria-label="Поиск">
        </form> v-if="platform.type == 'shop' || platform.type == 'market'" -->

<div v-if="(platform.type == 'market' || platform.marketplace_count > 0) && platform.type != 'trc' && platform.type != 'photo'" @click="openCart()" class="h-noti_icon" id="hcart">
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M8.80994 2L5.18994 5.63" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.1899 2L18.8099 5.63" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M2 7.84998C2 5.99998 2.99 5.84998 4.22 5.84998H19.78C21.01 5.84998 22 5.99998 22 7.84998C22 9.99998 21.01 9.84998 19.78 9.84998H4.22C2.99 9.84998 2 9.99998 2 7.84998Z" stroke="currentColor" stroke-width="1.5"/>
<path d="M9.76001 14V17.55" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
<path d="M14.36 14V17.55" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
<path d="M3.5 10L4.91 18.64C5.23 20.58 6 22 8.86 22H14.89C18 22 18.46 20.64 18.82 18.76L20.5 10" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
</svg>
<span v-if="cart" class="cart_header_count">{{ cart.length }}</span>

</div>

 <!-- <router-link :to="{ name:'about.index' }"  @click="openCart()" class="h-noti_icon">
 <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M8.0001 3H9.0001C7.0501 8.84 7.0501 15.16 9.0001 21H8.0001" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15 3C16.95 8.84 16.95 15.16 15 21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3 16V15C8.84 16.95 15.16 16.95 21 15V16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M3 8.99998C8.84 7.04998 15.16 7.04998 21 8.99998" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

</router-link> -->

        <router-link v-if="!this.token && platform.id != 34241 && platform.id != 34242 && platform.id != 34243 && platform.id != 34246 && platform.id != 34247 && platform.id != 34248 && platform.type != 1 && platform.type != 'oplata'" :to="{ name: 'user.login' }" class="h-btn_login">Войти</router-link>
 <router-link v-if="platform.type == 'oplata'" :to="{ name: 'faq.index' }" :class="platform.stype == 1 ? 'new_faq_w' : 'new_faq'" class="h-btn_login">FAQ</router-link>

        <div v-if="this.token && platform.type != 'wedding' && platform.type != 'birthday' && platform.type != 'babyparty' && platform.type != 'trc' && platform.type != 'photo' && platform.type != 'newyear'" class="h-noti_icon" @click="openNoti()">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.0201 2.91003C8.71009 2.91003 6.02009 5.60003 6.02009 8.91003V11.8C6.02009 12.41 5.76009 13.34 5.45009 13.86L4.30009 15.77C3.59009 16.95 4.08009 18.26 5.38009 18.7C9.69009 20.14 14.3401 20.14 18.6501 18.7C19.8601 18.3 20.3901 16.87 19.7301 15.77L18.5801 13.86C18.2801 13.34 18.0201 12.41 18.0201 11.8V8.91003C18.0201 5.61003 15.3201 2.91003 12.0201 2.91003Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round"/>
<path d="M13.8699 3.19994C13.5599 3.10994 13.2399 3.03994 12.9099 2.99994C11.9499 2.87994 11.0299 2.94994 10.1699 3.19994C10.4599 2.45994 11.1799 1.93994 12.0199 1.93994C12.8599 1.93994 13.5799 2.45994 13.8699 3.19994Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M15.02 19.0601C15.02 20.7101 13.67 22.0601 12.02 22.0601C11.2 22.0601 10.44 21.7201 9.90002 21.1801C9.36002 20.6401 9.02002 19.8801 9.02002 19.0601" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10"/>
</svg>
<span v-if="notis_count > 0" class="cart_header_count">{{ notis_count }}</span>
        </div>

        <router-link :to="{ name: 'messenger.index' }" v-if="this.token && platform.type != 'babygum' && platform.type != 'wedding' && platform.type != 'birthday' && platform.type != 'babyparty' && platform.type != 'kinder' && platform.type != 'trc' && platform.type != 'photo' && platform.type != 'newyear'" class="h-noti_icon m-hidden">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M18.4701 16.83L18.8601 19.99C18.9601 20.82 18.0701 21.4 17.3601 20.97L13.1701 18.48C12.7101 18.48 12.2601 18.45 11.8201 18.39C12.5601 17.52 13.0001 16.42 13.0001 15.23C13.0001 12.39 10.5401 10.09 7.50009 10.09C6.34009 10.09 5.2701 10.42 4.3801 11C4.3501 10.75 4.34009 10.5 4.34009 10.24C4.34009 5.68999 8.29009 2 13.1701 2C18.0501 2 22.0001 5.68999 22.0001 10.24C22.0001 12.94 20.6101 15.33 18.4701 16.83Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M13 15.23C13 16.42 12.56 17.52 11.82 18.39C10.83 19.59 9.26 20.36 7.5 20.36L4.89 21.91C4.45 22.18 3.89 21.81 3.95 21.3L4.2 19.33C2.86 18.4 2 16.91 2 15.23C2 13.47 2.94 11.92 4.38 11C5.27 10.42 6.34 10.09 7.5 10.09C10.54 10.09 13 12.39 13 15.23Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
        </router-link>

        <div v-if="(this.token && (platform.type == 'wedding' || platform.type == 'birthday' || platform.type == 'babyparty' || platform.type == 'newyear' || platform.type == 'photo'  || (platform.type == 'kinder' && isAccess() == 'open'))) || (this.token && !isMobile && platform.type != 'kinder' && platform.type != 'trc')" class="dropdown hcrate">
          <button class="h-noti_icon" type="button" id="createContents" data-bs-toggle="dropdown" aria-expanded="false">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 12H16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M12 16V8" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M9 22H15C20 22 22 20 22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
    </button>
    <div class="dropdown-menu" aria-labelledby="createContents">
      <a v-if="platform.type != 'wedding' && platform.type != 'birthday' && platform.type != 'babyparty' && platform.type != 'newyear'" class="dropdown-item" href="#" @click.prevent="isCreate = 'lenta'">
         <div class="create_content_dropdown">
              <div class="create_content_dropdown-icon"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M13.01 2.92001L18.91 5.54001C20.61 6.29001 20.61 7.53001 18.91 8.28001L13.01 10.9C12.34 11.2 11.24 11.2 10.57 10.9L4.67002 8.28001C2.97002 7.53001 2.97002 6.29001 4.67002 5.54001L10.57 2.92001C11.24 2.62001 12.34 2.62001 13.01 2.92001Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  <path d="M3 11C3 11.84 3.63 12.81 4.4 13.15L11.19 16.17C11.71 16.4 12.3 16.4 12.81 16.17L19.6 13.15C20.37 12.81 21 11.84 21 11" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  <path d="M3 16C3 16.93 3.55 17.77 4.4 18.15L11.19 21.17C11.71 21.4 12.3 21.4 12.81 21.17L19.6 18.15C20.45 17.77 21 16.93 21 16" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg></div>
              <div class="create_content_dropdown-text" >
                  <div class="create_content_dropdown-text_top">Ленту</div>
                  <div v-if="platform.type == 'photo'" class="create_content_dropdown-text_buttom">Собирайте посты из фото, видео, файлов в одном месте.</div>
                  <div v-else class="create_content_dropdown-text_buttom">Собирайте любимые сообщества из разных социальных сетей в одном месте.</div>
                  
              </div>
         </div>
      </a>
      <a v-if="platform.type != 'wedding' && platform.type != 'birthday' && platform.type != 'babyparty' && platform.type != 'kinder' && platform.type != 'newyear' && platform.type != 'photo'" class="dropdown-item" href="#" @click.prevent="isCreate = 'episode'">
         <div class="create_content_dropdown">
              <div class="create_content_dropdown-icon"><svg class="icon-bg-photos" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.68 16.9599L18.55 9.64988C17.49 7.16988 15.54 7.06988 14.23 9.42988L12.34 12.8399C11.38 14.5699 9.59 14.7199 8.35 13.1699L8.13 12.8899C6.84 11.2699 5.02 11.4699 4.09 13.3199L2.37 16.7699C1.16 19.1699 2.91 21.9999 5.59 21.9999H18.35C20.95 21.9999 22.7 19.3499 21.68 16.9599Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  <path d="M6.97 8C8.62686 8 9.97 6.65685 9.97 5C9.97 3.34315 8.62686 2 6.97 2C5.31315 2 3.97 3.34315 3.97 5C3.97 6.65685 5.31315 8 6.97 8Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg></div>
              <div class="create_content_dropdown-text">
                  <div class="create_content_dropdown-text_top">Фотографию</div>
                  <div class="create_content_dropdown-text_buttom">Делитесь яркими моментами своей жизни со своими подписчиками</div>
              </div>
         </div>
      </a>
      <a v-if="platform.type == 'wedding' || platform.type == 'birthday' || platform.type == 'babyparty' || platform.type == 'kinder' || platform.type == 'newyear' || platform.type == 'photo'" class="dropdown-item" href="#" @click.prevent="isCreate = 'episode'">
         <div class="create_content_dropdown">
              <div class="create_content_dropdown-icon"><svg class="icon-bg-photos" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M21.68 16.9599L18.55 9.64988C17.49 7.16988 15.54 7.06988 14.23 9.42988L12.34 12.8399C11.38 14.5699 9.59 14.7199 8.35 13.1699L8.13 12.8899C6.84 11.2699 5.02 11.4699 4.09 13.3199L2.37 16.7699C1.16 19.1699 2.91 21.9999 5.59 21.9999H18.35C20.95 21.9999 22.7 19.3499 21.68 16.9599Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  <path d="M6.97 8C8.62686 8 9.97 6.65685 9.97 5C9.97 3.34315 8.62686 2 6.97 2C5.31315 2 3.97 3.34315 3.97 5C3.97 6.65685 5.31315 8 6.97 8Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg></div>
              <div class="create_content_dropdown-text">
                  <div class="create_content_dropdown-text_top">Фотографию</div>
                  <div class="create_content_dropdown-text_buttom">Делитесь яркими моментами в формате фото</div>
              </div>
         </div>
      </a>

      <a v-if="platform.type == 'babygum' || platform.type == 'wedding' || platform.type == 'birthday' || platform.type == 'babyparty' || platform.type == 'kinder' || platform.type == 'newyear' || platform.type == 'photo'" class="dropdown-item" href="#" @click.prevent="isCreate = 'Addvideo'">
         <div class="create_content_dropdown">
              <div class="create_content_dropdown-icon"><svg class="icon-bg-videos" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M22 15V9C22 4 20 2 15 2H9C4 2 2 4 2 9V15C2 20 4 22 9 22H15C20 22 22 20 22 15Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  <path d="M2.52 7.11011H21.48" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  <path d="M8.52 2.11011V6.97011" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  <path d="M15.48 2.11011V6.52011" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path>
  <path d="M9.75 14.4501V13.2501C9.75 11.7101 10.84 11.0801 12.17 11.8501L13.21 12.4501L14.25 13.0501C15.58 13.8201 15.58 15.0801 14.25 15.8501L13.21 16.4501L12.17 17.0501C10.84 17.8201 9.75 17.1901 9.75 15.6501V14.4501V14.4501Z" stroke="currentColor" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round"></path>
  </svg></div>
              <div class="create_content_dropdown-text">
                  <div class="create_content_dropdown-text_top">Ролик</div>
                  <div class="create_content_dropdown-text_buttom">Делитесь моментами в видео формате</div>
              </div>
         </div>
      </a>

    </div>
        </div> 

         <div v-if="this.token" class="dropdown text-end">
          <a href="#" class="d-block link-dark text-decoration-none dropdown-toggle" id="dropdownUser1" data-bs-toggle="dropdown" aria-expanded="false">
            <img v-if="this.user.photo !== 'null'" :src="this.user.photo" alt="mdo" class="h-profile_avatar rounded-circle">
          </a>
          <ul class="dropdown-menu text-small" aria-labelledby="dropdownUser1" style="">
             
            
             <li v-if="this.token && (platform.type == 'babygum' || platform.type == 'wedding' || platform.type == 'birthday' || platform.type == 'babyparty' || platform.type == 'photo' || platform.type == 'newyear')"><router-link class="dropdown-item" :to="{ name: 'user.profile', params: {'uid' : user.id} }">Профиль</router-link></li>
             <li><router-link :to="{ name: 'about.index'}" v-if="platform.type == 'wedding' || platform.type == 'birthday' || platform.type == 'babyparty'  || platform.type == 'photo' || platform.type == 'newyear'" class="dropdown-item">О нас</router-link></li>
             <li v-if="this.token && (user.role == 31 || user.role == 32)"><router-link :to="{ name: 'admin.index'}" class="dropdown-item">Управление</router-link></li> 
            <li v-if="this.token && user.ref_active == 11"><router-link :to="{ name: 'user.referal', params: {'uid' : user.id} }" class="dropdown-item">Реф.система</router-link></li>
            <li><a class="dropdown-item" href="#" v-if="user != null && user.id == 791591">Совместные покупки</a></li>
            <li><a class="dropdown-item" v-if="platform.type == 'shop' || platform.type == 'market'" href="#" @click.prevent="openOrders">Мои заказы</a></li>
            <li><router-link :to="{ name: 'market.index'}" class="dropdown-item" v-if="platform.type == 'market'">Наш магазин</router-link></li>
            <li v-if="platform.type != 'trc' && platform.type != 'wedding' && platform.type != 'birthday' && platform.type != 'babyparty' && platform.type != 'photo' && platform.type != 'newyear' || platform.type != 'photo'"><a class="dropdown-item" href="#" @click.prevent="enablePush">Включить PUSH-уведомления</a></li>
            
            <li v-if="platform.type != 'trc' && false"><a class="dropdown-item" href="#" @click.prevent="swapTheme">Тема: {{ (theme == 'darkTheme') ? 'Темная' : 'Светлая'}}</a></li>
            <!-- <li><a class="dropdown-item" href="#">Помощь</a></li> -->
            <li><hr class="dropdown-divider"></li>
            <li><a class="dropdown-item" @click.prevent="logout" href="#">Выйти</a></li>
          </ul>
        </div> 
      </div>
    </div>
  </header>
  <component v-if="isCreate" :is="isCreate" :kinder_groups="kinder_groups" :platform="platform" @remove="closeModal"></component>
 </div>
</template>

<script>
import Noti from '../user/Noti.vue';
import Cart from '../shop/Cart.vue';
import Orders from '../shop/Orders.vue';
import Lenta from '../modal/create/Lenta.vue';
import Episode from '../modal/create/Episode.vue';
import Story from '../modal/create/Story.vue';
import Addvideo from '../modal/create/Addvideo.vue';
export default {
  name: 'HeaderBlock',
  components: { Cart, Orders, Noti, Lenta, Episode, Story, Addvideo },
  props: ['token', 'user', 'uid', 'platform', 'cart', 'order', 'isMobile', 'cartMarkets', 'hasShop'],
  data(){
    return {
      theme: 'whiteTheme',
      isCreate: null,
      showCart: false,
      showOrders: false,
      notis_count: 0,
      loadNoti: false,
      showNotis: false,
      kinder_groups: [],
    }
  },
  mounted(){
  this.getTheme()
  },

  emits: ['getCart'],
  watch: {
    'uid' (newVal, oldVal) {
      if(newVal > 0 && newVal != oldVal){
    this.getNotiCount()

  }
    },
    'platform' (newVal, oldVal) {
      if(newVal != null){
this.loadKinderGroup()
  }
    }
  },

   methods:{
    loadKinderGroup() {
      if(this.platform.type != 'kinder' || this.isAccess() != 'open'){
        return
      }
      //console.log('loadKInder: '+this.platform.type);
axios.get('/api/kinder.get.groups')
                .then( res => {
                   this.kinder_groups = Array.isArray(res.data.data) ? res.data.data : [];
                }).catch( error => {
    
       })
    },
    isAccess(){
      if(this.user && (this.user.role == 31 || this.user.role == 32 || this.user.role == 35 || this.user.role == 37)){
        return 'open'
      }
      return 'close'
    },
    enablePush(){
      Notification.requestPermission()
    },
  
    openNoti(){
      this.hiddenScroll();
      if(this.showNotis == true){
          this.showNotis = false
      }else{
          this.showNotis = true
      }
    },
    getNotiCount(){
      if(!this.token || this.loadNoti){
        return;
      }
      axios.post('/api/user.get.notis', {'type': 'newCount'})
                .then( res => {
                  if(res.data.status == 'success'){
                    this.notis_count = res.data.data
                    this.loadNoti = true
                  }
                }).catch( error => {
    
       })
    },
    openOrders(type = null){
      
      this.hiddenScroll();
      if(this.showOrders == true){
          this.showOrders = false
      }else{
          this.showOrders = true
      }
  },
    hiddenScroll(){
        const body = document.querySelector('body');
        body.classList.toggle("overflow-hidden");
      },
      closeModal(status) {
		  this.isCreate = status
	  },
    openCart(type = null){
     
            this.hiddenScroll();
            if(this.showCart == true){
                this.showCart = false
            }else{
                this.showCart = true
            }
            if(type == 'reload'){
              this.$emit('getCart', null)
              this.openOrders()
            }
        },
    logout(){
      axios.post('/logout')
                .then( res => {
                  localStorage.removeItem('x_xsrf_token')
                  this.loadNoti = false
                  this.$emit('userLogout', null)
                }).catch( error => {
                    alert(error.response.data.message);
       })
    },
    swapTheme(){
      if(this.theme == null || this.theme == 'whiteTheme'){
        localStorage.setItem('site_theme', 'darkTheme')
      }else{
        localStorage.setItem('site_theme', 'whiteTheme')
      }
      this.getTheme()
      axios.post('/api/theme.change')
    },
    getTheme(){
         this.theme = localStorage.getItem('site_theme')
         if(this.theme == 'darkTheme'){
          document.querySelector("html").classList.add(this.theme)
         }else{
          document.querySelector("html").classList.remove('darkTheme')
         } 


    }
   },
}
</script>

<style scoped>
.auto-width {
  max-width: max-content !important;
}
.h-btn_login.new_faq{
  background-color: rgba(245, 166, 35, 0.2);
    color: #f77600;
}
.h-btn_login.new_faq_w{
    /*background-color: #c6baaa;*/
    /*color: #4a3e2e ;*/
    background-color: rgba(245, 166, 35, 0.2);
    color: #f77600;
}
</style>
